import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icon_loading.svg'


const _hoisted_1 = {
  key: 0,
  class: "c-icon c-icon--search"
}
const _hoisted_2 = ["type", "placeholder", "value", "error", "disabled", "maxLength", "onchange", "tabIndex"]
const _hoisted_3 = {
  key: 0,
  class: "size-[22px] absolute top-[50%] translate-y-[-50%] right-[10px]",
  src: _imports_0
}
const _hoisted_4 = { class: "s-hide" }
const _hoisted_5 = { class: "c-form__msg" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
  type: {
    type: String,
    default: 'text',
  },
  modelValue: {
    type: [String, Number],
  },
  updateValue: {
    type: String,
  },
  size: {
    type: String,
    default: 'medium',
  },
  state: {
    type: String,
    default: 'default',
  },
  message: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
  },
  icon: {
    type: String,
    default: '',
  },
  error: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  maxLength: {
    type: Number,
  },
  onlyNumber: {
    type: Boolean,
    default: false,
  },
  align: {
    type: String,
    default: '',
  },
  onChange: Function,
  onClick: Function,
  onEnterKeyUp: Function,
  onTabKeyUp: Function,
  inputRef: {
    type: Object,
    default: () => {},
  },
  tabIndex: {
    type: Number,
    default: 1,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:modelValue', 'focusin', 'focusout'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const updateValue = (e: Event) => {
  emit('update:modelValue', (e.target as HTMLInputElement).value);
};
const iconbutton = async () => {
  if (props.onClick) {
    try {
      const result = props.onClick();
      if (result instanceof Promise) {
        await result;
      }
    } catch (error) {
      console.error('에러 발생:', error);
    }
  }
};
const onlyNumber = (e: KeyboardEvent) => {
  if (!props.onlyNumber) return;

  const key = e.key;
  const isNumber = key >= '0' && key <= '9';
  const isControlKey =
    key === 'Backspace' || key === 'Delete' || key === 'ArrowLeft' || key === 'ArrowRight';

  if (!isNumber && !isControlKey && key !== '.') {
    e.preventDefault();
  }
  // if (!props.onlyNumber) return;
  // let keyCode = e.keyCode ? e.keyCode : e.which;
  // // 8 is backspace
  // if (keyCode === 8) return;
  // if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
  //   // 46 is dot
  //   e.preventDefault();
  // }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`
      c-form c-form--${__props.state} 
      ${__props.icon.length > 0 && !__props.disabled && 'c-form--icon'} 
      c-form--${__props.size} c-form--${__props.error ? 'error' : 'default'} 
      c-form--${__props.type ? `${__props.type}` : 'default'}
      ${__props.align && `c-form--${__props.align}`}
      ${__props.align && `c-form--${__props.align}`} 
    `)
  }, [
    (__props.type == 'search')
      ? (_openBlock(), _createElementBlock("i", _hoisted_1, _cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "s-hide" }, "search", -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: __props.type,
      class: _normalizeClass(`
        c-form__input
      `),
      placeholder: __props.placeholder,
      value: __props.modelValue,
      error: __props.error,
      disabled: __props.disabled || __props.isLoading,
      maxLength: __props.maxLength,
      onchange: __props.onChange,
      onKeydown: onlyNumber,
      onInput: updateValue,
      onFocusin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('focusin', $event))),
      onFocusout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('focusout', $event))),
      onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (__props.onEnterKeyUp && __props.onEnterKeyUp(...args)), ["enter"])),
      tabIndex: __props.tabIndex,
      ref: __props.inputRef
    }, null, 40, _hoisted_2),
    _createElementVNode("button", {
      type: "button",
      onClick: iconbutton
    }, [
      (__props.icon.length > 0 && !__props.disabled)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (__props.isLoading)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : (_openBlock(), _createElementBlock("i", {
                  key: 1,
                  class: _normalizeClass(`c-form__icon c-form__icon--${__props.icon}`)
                }, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(__props.icon), 1)
                ], 2))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.message), 1)
  ], 2))
}
}

})